import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Go back to previous page
  };

  const handleGoHome = () => {
    navigate('/'); // Navigate to home page
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <WarningIcon color="error" sx={{ fontSize: 80, mb: 2 }} />

        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
          Unauthorized Access
        </Typography>

        <Typography variant="body1" paragraph>
          You don't have permission to access this page.
        </Typography>

        <Typography variant="body1" paragraph sx={{ mb: 4 }}>
          Please contact your administrator if you believe this is an error.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button variant="outlined" onClick={handleGoBack} sx={{ px: 4 }}>
            Go Back
          </Button>

         
        </Box>
      </Paper>
    </Container>
  );
};

export default UnauthorizedPage;
